import { dataSyncEmitter } from "@/modules/events/emitter";
import { useEffect } from "react";

export function useDisableNavigationEvents(keepDisabled = true) {
  useEffect(() => {
    dataSyncEmitter.emit("set-navigation-events", true);
    return () => dataSyncEmitter.emit("set-navigation-events", keepDisabled);
  }, [keepDisabled]);
}
